import { dashBoardReportRegisteredUserService, dashBoardReportService, dashBoardReportWorkoutService } from "../../services/dashBoardReports";
import { types } from "./types";

export const dashBoardReportAction = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await dashBoardReportService(data);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.DASHBOARD_REPORTS_ACTIVE_USERS, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.DASHBOARD_REPORTS_ACTIVE_USERS,
      payload: {
        male: {
          dates: [],
          recordcounts: []
        },
        female: {
          dates: [],
          recordcounts: []
        },
        total: {
          dates: [],
          recordcounts: []
        },
        uniqueActiveUsers: {
          male: 0,
          female: 0
        }
      }
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const dashBoardReportRegisteredUsersAction = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await dashBoardReportRegisteredUserService(data);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.DASHBOARD_REPORTS_REGISTERED_USERS, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.DASHBOARD_REPORTS_REGISTERED_USERS,
      payload: [],
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};

export const dashBoardReportWorkOutSessionsAction = (data) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await dashBoardReportWorkoutService(data);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.DASHBOARD_REPORTS_WORKOUT_SESSIONS, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.DASHBOARD_REPORTS_WORKOUT_SESSIONS,
      payload: [],
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};
